/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './main-menu.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/router';
import * as i5 from '@angular/common';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '../back-button/back-button.component.ngfactory';
import * as i8 from '../../../../../../app/modules/layout/components/back-button/back-button.component';
import * as i9 from '../../../utilities/components/request-support/request-support-button.component.ngfactory';
import * as i10 from '../../../../../../app/modules/utilities/components/request-support/request-support-button.component';
import * as i11 from '../../../../../../app/modules/utilities/services/request-support/request-support.service';
import * as i12 from '../../../../../../app/modules/utilities/services/confirmation-dialog/confirmation-dialog.service';
import * as i13 from '../../../../../../app/modules/layout/components/main-menu/main-menu.component';
import * as i14 from '../../../../../../app/modules/user/services/auth/auth.service';
import * as i15 from '../../../../../../app/modules/user/services/current-user/current-user.service';
import * as i16 from '../../../../../../app/modules/airport/services/airport/airport.service';
const styles_MainMenuComponent:any[] = [i0.styles];
export const RenderType_MainMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MainMenuComponent,data:{}});
function View_MainMenuComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'a',[['class',
      'mat-list-item'],['md-list-item',''],['role','listitem']],[[2,'active',(null as any)],
      [1,'target',0],[8,'href',4]],[[(null as any),'click'],[(null as any),'focus'],
      [(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('focus' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleFocus()) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleBlur()) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,4).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_2 && ad);
    }
    if (('click' === en)) {
      const pd_3:any = ((<any>_co.onItemClick((<any>_v.parent).context.$implicit,(<any>_v.parent).context.index)) !== false);
      ad = (pd_3 && ad);
    }
    return ad;
  },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(1,1097728,(null as any),
      2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],
      (null as any),(null as any)),i1.ɵqud(603979776,1,{_lines:1}),i1.ɵqud(335544320,
      2,{_hasAvatar:0}),i1.ɵdid(4,671744,(null as any),0,i4.RouterLinkWithHref,[i4.Router,
      i4.ActivatedRoute,i5.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),
      (_l()(),i1.ɵted(5,2,['\n      ','\n    ']))],(_ck,_v) => {
    const currVal_3:any = (<any>_v.parent).context.$implicit.url;
    _ck(_v,4,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.active;
    const currVal_1:any = i1.ɵnov(_v,4).target;
    const currVal_2:any = i1.ɵnov(_v,4).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = (<any>_v.parent).context.$implicit.label;
    _ck(_v,5,0,currVal_4);
  });
}
function View_MainMenuComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'md-list-item',
      [['class','mat-list-item'],['role','listitem']],(null as any),[[(null as any),
          'focus'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2)._handleFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleBlur()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(1,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,1097728,(null as any),2,i3.MdListItem,[i1.Renderer2,
      i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),
      i1.ɵqud(603979776,3,{_lines:1}),i1.ɵqud(335544320,4,{_hasAvatar:0}),(_l()(),
          i1.ɵted(5,2,['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.label;
    _ck(_v,5,0,currVal_0);
  });
}
function View_MainMenuComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'a',[['class',
      'mat-list-item'],['md-list-item',''],['role','listitem']],[[2,'active',(null as any)],
      [1,'target',0],[8,'href',4]],[[(null as any),'click'],[(null as any),'focus'],
      [(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('focus' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleFocus()) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleBlur()) !== false);
      ad = (pd_1 && ad);
    }
    if (('click' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,4).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_2 && ad);
    }
    if (('click' === en)) {
      const pd_3:any = ((<any>_co.onClickSubItem((<any>(<any>_v.parent).parent).context.index,
          _v.context.$implicit,_v.context.index)) !== false);
      ad = (pd_3 && ad);
    }
    return ad;
  },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(1,1097728,(null as any),
      2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],
      (null as any),(null as any)),i1.ɵqud(603979776,5,{_lines:1}),i1.ɵqud(335544320,
      6,{_hasAvatar:0}),i1.ɵdid(4,671744,(null as any),0,i4.RouterLinkWithHref,[i4.Router,
      i4.ActivatedRoute,i5.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),
      (_l()(),i1.ɵted(5,2,['\n          ','\n        ']))],(_ck,_v) => {
    const currVal_3:any = _v.context.$implicit.url;
    _ck(_v,4,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.active;
    const currVal_1:any = i1.ɵnov(_v,4).target;
    const currVal_2:any = i1.ɵnov(_v,4).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = _v.context.$implicit.label;
    _ck(_v,5,0,currVal_4);
  });
}
function View_MainMenuComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),7,'md-list',[['class','sub-list mat-list'],['role','list']],
          (null as any),(null as any),(null as any),i2.View_MdList_0,i2.RenderType_MdList)),
      i1.ɵdid(3,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(4,49152,(null as any),
          0,i3.MdList,([] as any[]),(null as any),(null as any)),i1.ɵdid(5,16384,(null as any),
          0,i3.MdListCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,
          (null as any),View_MainMenuComponent_5)),i1.ɵdid(8,802816,(null as any),
          0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,0,['\n      '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.children;
    _ck(_v,8,0,currVal_0);
  },(null as any));
}
function View_MainMenuComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_MainMenuComponent_2)),i1.ɵdid(3,16384,
          (null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_MainMenuComponent_3)),i1.ɵdid(6,
          16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MainMenuComponent_4)),
      i1.ɵdid(9,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.shouldDisplayMenuItem(_v.context.$implicit);
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.shouldDisplayParent(_v.context.$implicit);
        _ck(_v,6,0,currVal_1);
        const currVal_2:any = (_v.context.$implicit.children !== (undefined as any));
        _ck(_v,9,0,currVal_2);
      },(null as any));
}
function View_MainMenuComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'btn-logout mat-button'],['md-button','']],[[8,'disabled',0]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.auth.logout()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,180224,(null as any),0,i3.MdButton,[i1.Renderer2,i1.ElementRef,i6.Platform,
          i3.FocusOriginMonitor],(null as any),(null as any)),i1.ɵdid(3,16384,(null as any),
          0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['Log Out']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
export function View_MainMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'img',[['class',
      'logo'],['src','../../../../../assets/img/logo.png']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),1,'app-back-button',
      ([] as any[]),(null as any),(null as any),(null as any),i7.View_BackButtonComponent_0,
      i7.RenderType_BackButtonComponent)),i1.ɵdid(3,114688,(null as any),0,i8.BackButtonComponent,
      [i5.Location],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),7,'md-list',[['class',
      'mat-list'],['role','list']],(null as any),(null as any),(null as any),i2.View_MdList_0,
      i2.RenderType_MdList)),i1.ɵdid(6,16384,(null as any),0,i3.MdPrefixRejector,[[2,
      i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(7,49152,(null as any),0,i3.MdList,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(8,16384,(null as any),0,i3.MdListCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_MainMenuComponent_1)),i1.ɵdid(11,802816,
          (null as any),0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,0,['\n'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(14,0,(null as any),(null as any),
          7,'div',[['class','menu-footer']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MainMenuComponent_6)),
      i1.ɵdid(17,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(19,0,(null as any),(null as any),1,'app-request-support-button',
          ([] as any[]),(null as any),(null as any),(null as any),i9.View_RequestSupportButtonComponent_0,
          i9.RenderType_RequestSupportButtonComponent)),i1.ɵdid(20,49152,(null as any),
          0,i10.RequestSupportButtonComponent,[i3.MdDialog,i11.RequestSupportService,
              i12.ConfirmationDialogService],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i13.MainMenuComponent = _v.component;
        _ck(_v,3,0);
        const currVal_0:any = _co.menuItems;
        _ck(_v,11,0,currVal_0);
        const currVal_1:any = _co.auth.isAuthenticated();
        _ck(_v,17,0,currVal_1);
      },(null as any));
}
export function View_MainMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-main-menu',
      ([] as any[]),(null as any),(null as any),(null as any),View_MainMenuComponent_0,
      RenderType_MainMenuComponent)),i1.ɵdid(1,114688,(null as any),0,i13.MainMenuComponent,
      [i14.AuthService,i4.Router,i15.CurrentUserService,i16.AirportService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const MainMenuComponentNgFactory:i1.ComponentFactory<i13.MainMenuComponent> = i1.ɵccf('app-main-menu',
    i13.MainMenuComponent,View_MainMenuComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/main-menu/main-menu.component.ngfactory.ts